import {
  buildLogisticsProgressQueryPayload,
  isTrackedLogisticsAsset,
  mergeLogisticsProgressIntoAssets,
  normalizeLogisticsProgressQueryResponse,
} from "../features/Logistics/models/logisticsProgressPayload";
import { queryLogisticsProgress } from "../features/Logistics/services/logisticsProgressService";

const TYPE_MAP = {
  asset: "equipment",
  assets: "equipment",
  equipment: "equipment",
  equipments: "equipment",
  tier: "tier",
  tiers: "tier",
  "sub-asset": "tier",
  "sub-assets": "tier",
  component: "panelcomponent",
  components: "panelcomponent",
  panelcomponent: "panelcomponent",
  "panel-component": "panelcomponent",
  "panel-components": "panelcomponent",
  instrument: "instrument",
  instruments: "instrument",
};

const normalizeObjectType = (type) => {
  if (!type) return "";

  const normalizedType = String(type).trim();
  return TYPE_MAP[normalizedType.toLowerCase()] || normalizedType;
};

const getObjectType = (item, fallbackType) => {
  const type =
    item.objectType ||
    item.object_type ||
    item.contentType ||
    item.content_type ||
    item._type ||
    fallbackType;

  if (type) return normalizeObjectType(type);
  if (item.tierName) return "tier";
  if (item.componentName) return "panelcomponent";
  if (item.instrumentType || item.instrument_type_details) return "instrument";

  return "equipment";
};

const getObjectId = (item) =>
  String(item.objectId ?? item.object_id ?? item.id ?? item.pk ?? "");

export const getLogisticsIdentityKey = (item) =>
  String(item?.uid || `${item?.objectType || ""}:${item?.objectId || ""}`);

export const withLogisticsIdentity = (item, fallbackType) => {
  if (!item || typeof item !== "object") return item;

  const objectType = getObjectType(item, fallbackType);
  const objectId = getObjectId(item);
  const uid =
    item.uid || (objectType && objectId ? `${objectType}:${objectId}` : "");

  return {
    ...item,
    uid,
    objectType,
    objectId,
  };
};

export const normalizeLogisticsProgressItems = (items = [], fallbackType) =>
  items
    .filter((item) => item && typeof item === "object")
    .map((item) => withLogisticsIdentity(item, fallbackType));

export const resolveLogisticsDisplayItem = (
  selectedItem,
  enrichedItems = [],
) => {
  if (!selectedItem) return null;

  return (
    enrichedItems.find(
      (item) => String(item?.id) === String(selectedItem.id),
    ) || selectedItem
  );
};

export const queryAndMergeLogisticsProgress = async (
  items = [],
  fallbackType,
  options = {},
) => {
  const normalizedItems = normalizeLogisticsProgressItems(items, fallbackType);

  if (!normalizedItems.length) return normalizedItems;

  const queryableItems = normalizedItems.filter(
    (item) => item.uid && item.objectType && item.objectId && isTrackedLogisticsAsset(item),
  );

  if (!queryableItems.length) {
    return mergeLogisticsProgressIntoAssets(normalizedItems, []);
  }

  try {
    const payload = buildLogisticsProgressQueryPayload(queryableItems);
    const data = await queryLogisticsProgress(payload, options);
    const progressResults = normalizeLogisticsProgressQueryResponse(data);

    return mergeLogisticsProgressIntoAssets(normalizedItems, progressResults);
  } catch (error) {
    options.onError?.(error);
    return mergeLogisticsProgressIntoAssets(normalizedItems, []);
  }
};
